import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { GroupRightsComponent }       from './group-rights.component';
import { GroupRightsGroupsComponent } from './group-rights.groups.component';
import { GroupRightsService }         from './group-rights.service';
import { GroupRightsStates }          from './group-rights.states';
import { SharedModule }               from '../shared/shared.module';

@NgModule({
  declarations: [
    GroupRightsComponent,
    GroupRightsGroupsComponent
  ],
  entryComponents: [
    GroupRightsComponent,
    GroupRightsGroupsComponent
  ],
  imports: [
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: GroupRightsStates })
  ],
  providers: [
    GroupRightsService
  ]
})
export class GroupsRightsModule {}
